// Highlighting for code blocks
// https://prismjs.com/download.html#themes=prism-tomorrow&languages=markup+css+clike+javascript+jsx
// import './src/styles/prism.css'
import { pageWrapper } from './gatsby-wrapper'
import { rootWrapper } from './gatsby-wrapper'

export const wrapRootElement = rootWrapper
export const wrapPageElement = pageWrapper
